import { FC } from "react";
import styles from "./widget-container.module.css";
import { WidgetContainerProps } from "./widget-container.types";

const WidgetContainer: FC<WidgetContainerProps> = ({
  id,
  children,
  className,
  style,
  containerClassName,
  highlight,
  fullWidth,
  withoutPadding,
  withoutPaddingX,
  withoutPaddingY
}) => {
  return (
    <section
      id={id}
      className={`${styles.widgetContainer} ${
      highlight ? styles.widgetContainerHighlight : ""
      } ${fullWidth ? styles.widgetContainerFull : ""} ${
      withoutPadding ? styles.widgetContainerWithoutPadding : ""
      } ${withoutPaddingX ? styles.widgetContainerWithoutPaddingX : ""} ${
      withoutPaddingY ? styles.widgetContainerWithoutPaddingY : ""
      } ${className || ""}`}
      style={style}>

      <div className={`${styles.container} ${containerClassName || ""}`}>
        {children}
      </div>
    </section>);

};

export default WidgetContainer;